<script setup lang="ts">
import { Section, Stack, Typography } from './core';

type Props = {
  didError: boolean;
  loadingIndicator: boolean;
};

const props = defineProps<Props>();
</script>
<template>
  <slot v-if="!props.loadingIndicator && !props.didError" />
  <slot v-if="!props.loadingIndicator && props.didError" name="error">
    <Section :footer="false">
      <Stack class="justify-center">
        <Typography variant="heading">
          Unable to show content
        </Typography>
        <Typography variant="body">
          Something went wrong, and we&rsquo;re unable to show this section. Try refreshing the page, and if the problem persists, please contact support for further assistance
        </Typography>
      </Stack>
    </Section>
  </slot>
</template>
